import React from 'react';
import { BrowserRouter as Router, Route, Routes, Link } from 'react-router-dom';

import Home from './screen/Home';
import Landing from './screen/Landing';
import About from './screen/About';
import CreateMovie from './screen/CreateMovie';
import EditMovie from './screen/EditMovie';
import MemeList from './screen/MemeList'
import MemeDetail from './screen/MemeDetails'
function App() {
  return (
    <Router>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/movie/new" element={<CreateMovie />} />
          <Route path="/movie/:id" element={<MemeList />} />
          <Route path="/movie/:id/edit" element={<EditMovie />} />
          <Route path="/movie/:id/meme/new" element={<Home />} />
          <Route path="/movie/:movieId/meme/:id" element={<MemeDetail />} />
          <Route path="/about" element={<About />} />
        </Routes>
    </Router>
  );
}

export default App;
